import "./jquery-2.js";
import "./com.js";
import "./hm.js";
import "./c_html_js_add.js";
import "./prism.js";
import "./zblogphp.js";